import {Component, Inject, OnDestroy, OnInit} from "@angular/core";
import {TableControllerService} from "../../../services/table-controller.service";
import {FilterControllerService} from "../../../services/filter-controller.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {HttpParams} from "@angular/common/http";
import {Subject, takeUntil} from "rxjs";
import {GeneralService} from "../../../services/crud/general.service";

@Component({
	selector: "dialog-upload-monitor-attachment.component",
	templateUrl: "./dialog-upload-monitor-attachment.component.html",
	styleUrls: ["./dialog-upload-monitor-attachment.component.scss"],
	host: {'class': 'h-100'},
	providers: [TableControllerService, FilterControllerService]
})
export class DialogUploadMonitorAttachmentComponent implements OnDestroy, OnInit
{
	private _interactionCycle: Subject<void> = new Subject<void>();

	// main page
	pageId: string;
	// id of the object to display (oem work with string ids)
	id: string;

	apiParent: string
	apiUrl: string;

	isLoading = true;
	selectedCategory = null;
	categoryOptions: any[] = [];

	constructor(
		public dialogRef: MatDialogRef<DialogUploadMonitorAttachmentComponent>,
		private generalDataService: GeneralService,
		// retrieve dialog input values
		@Inject(MAT_DIALOG_DATA) public data: any
	)
	{
		this.id = this.data['id'];
		this.apiUrl = this.data['apiUrl'] ?? 'monitor';
		this.apiParent = this.data['apiParent'] ?? 'detail';
	}


	/**
	 * ngOnInit load the layout information
	 */
	async ngOnInit()
	{
		console.info(`Loading page layout for ${this.pageId}`);
		this.setCombos();
		console.info(`End of loading page layout for ${this.pageId}`);
	}

	ngOnDestroy(): void
	{
		this._interactionCycle.next();
		this._interactionCycle.complete();
	}

	setCombos()
	{
		this.isLoading = true;
		let params = new HttpParams();
		params = params.set("comboId", "category");
		this.generalDataService.getData(this.apiParent + /*"/" + this.apiUrl +*/ "/monitor/monitor-header/combos", null, params).pipe(
			takeUntil(this._interactionCycle)
		).subscribe({
			next: (res: any) =>
			{
				this.categoryOptions = res.oContent;
				this.isLoading = false;
			},
			error: (err) =>
			{
				console.error("Error fetching data:", err);
				this.isLoading = false;
			}
		});
	}
}